module.exports = __webpack_public_path__ + "static/media/get_start_bg.020c41fe.png";